const getInitials = (str, len, space) => {
    const newStr = `${str}`
        .replace(/[^a-zA-Z ]/g, "")
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase())
        .join(space ? " " : "");

    if (len) {
        return newStr.substring(0, len);
    } else {
        return newStr.substring(0, 2);
    }
};

export const getUserFullName = (data) => {
    if (!data?.contractEmployer?.firstName || !data?.contractEmployer?.firstName)
        return data?.contractEmployer?.email;
    return data?.contractEmployer?.firstName + " " + data?.contractEmployer?.lastName;
};
export const getUserEmail = (data) => {
    return data?.contractEmployer?.email;
};

export default getInitials;
